import request from '../../components/api/api';
import {ROOT_URL} from '../../config';
import {
    fetchedDestinations,
    fetchedTripFormats,
    fetchedTypesOfWork,
    fetchedPageTags,
} from './actions';

export function fetchDestinations() {
    return (dispatch, getState) => {

        let state  = getState();
        let exists = state.taxonomy.allDestinations.length > 0;

        if (exists) {
            return;
        }

        let options = {
            url: `${ROOT_URL}/destinations`,
            method: 'GET'
        };

        return request(options, dispatch)
            .then(response => dispatch(fetchedDestinations(response.data)))
    };
}

export function fetchTripFormats() {
    return (dispatch, getState) => {

        let state  = getState();
        let exists = state.taxonomy.allTripFormats.length > 0;

        if (exists) {
            return;
        }

        let options = {
            url: `${ROOT_URL}/trip-format/meta-categories`,
            method: 'GET'
        };

        return request(options, dispatch)
            .then(response => dispatch(fetchedTripFormats(response.data)));
    };
}

export function fetchTypesOfWork() {
    return (dispatch, getState) => {

        let state  = getState();
        let exists = state.taxonomy.allTypesOfWork.length > 0;

        if (exists) {
            return;
        }

        let options = {
            url: `${ROOT_URL}/types-of-work`,
            method: 'GET'
        };

        return request(options, dispatch)
            .then(response => dispatch(fetchedTypesOfWork(response.data)));
    };
}

export function fetchPageTags(onlyTags) {

    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/tags-pages?onlyTags=${onlyTags}&_limit=1000`,
            method: 'GET',
        };

        return request(options, dispatch)
            .then(response => dispatch(fetchedPageTags(response.data)))
    }
}



// WEBPACK FOOTER //
// ./src/containers/taxonomy/thunks.js